export const CONTACT_METHOD = {
    ENROLMENT: "Enrolment",
    PARENT_HUB: "Parent Hub",
};
